import React from 'react';
import Helmet from 'react-helmet';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import moment from 'moment';
import { Edited } from './modals/Commons';
import { ImageDialog } from '../components/modals/ImageDialog';
import { Description } from '../components/Description';
import { FieldService } from '../services/Fields';
import { FieldImageService } from '../services/FieldImages';
import { validationByJoi } from '../utilities/commonValidation';
import {
  API,
  HEADER_CONSTANTS,
  DISPLAY_FLAG,
  APPROVAL_FILE_TYPE,
  FILE_EXTENSION_ID,
} from '../utilities/constants';
import dialogLoader from '../utilities/dialogLoader';
import { messageUtility } from '../utilities/messageUtility';
import ImageUtility from '../utilities/imageUtility';
import { deleteControlCode } from '../utilities/stringUtil';

/**
 * @description 帳票用画像・その他資料画面
 */
export class FieldImages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      created: null,
      updated: null,
      fieldImages: [],
      field: {},
      errors: {},
      fieldImageErrors: [],
      keyplanLists: [], // 取得キープラン情報
    };

    this.events = {
      form: {
        setFieldImageData: this.setFieldImageData.bind(this),
        setImage: this.setImage.bind(this),
        setImages: this.setImages.bind(this),
        removeImage: this.removeImage.bind(this),
        setPdf: this.setPdf.bind(this),
        addOtherImageForm: this.addOtherImageForm.bind(this),
        setFieldData: this.setFieldData.bind(this),
        submit: this.eventSubmit.bind(this),
      },
      modal: {},
    };

    this.styles = {
      label: {
        padding: '0 80px 0 0',
      },
      labelText: {
        lineHeight: 1.5,
      },
      item: {
        marginBottom: 10,
      },
      input: {
        float: 'left',
        marginBottom: 10,
      },
    };

    this.defaultValues = {
      id: null,
      category_code: null,
      file_name: null,
      image_url: '',
      file_type_id: '1',
      comment: '',
      pdf_name: '',
      file_extension_id: '',
    };

    this.fieldDefaultValues = {
      id: null,
      oxygen_lack_field_image_category_code: '0',
    };

    this.fieldSchema = Joi.object().keys({
      id: Joi.allow(),
      oxygen_lack_field_image_category_code: Joi.number(), // 酸欠帳票に使用するキープラン
    });

    this.etc_file_flag = true;

    this.imageFiles = [
      {
        category_code: 2, // 2:作業安全指示書用画像（特記事項、その他）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            作業安全指示書用画像
            <br />
            （特記事項、その他）欄
          </span>
        ),
        isDeleteButton: true,
      },
      {
        category_code: 12, // 12:現地ＫＹ記録表用画像（中央下部）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            現地ＫＹ記録表用画像
            <br />
            （中央下部）欄
          </span>
        ),
        isDeleteButton: true,
      },
      {
        category_code: 13, // 13:現地ＫＹ記録表用画像（右側下部）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            現地ＫＹ記録表用画像
            <br />
            （右側下部）欄
          </span>
        ),
        isDeleteButton: true,
      },
      {
        category_code: 14, // 14:作業安全指示書及び現地ＫＹ記録表用画像（中央下部）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            作業安全指示書及び
            <br />
            現地ＫＹ記録表用画像
            <br />
            （中央下部）欄
          </span>
        ),
        isDeleteButton: true,
      },
      {
        category_code: 15, // 15:作業安全指示書及び現地ＫＹ記録表用画像（右側下部）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            作業安全指示書及び
            <br />
            現地ＫＹ記録表用画像
            <br />
            （右側下部）欄
          </span>
        ),
        isDeleteButton: true,
      },
      {
        category_code: 16, // 16:酸欠帳票用画像（右側）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            酸欠帳票用画像
            <br />
            （右側）欄
          </span>
        ),
        isDeleteButton: true,
      },
      {
        category_code: 17, // 17:酸欠帳票用画像（下側）欄
        title: (
          <span className='label' style={this.styles.labelText}>
            酸欠帳票用画像
            <br />
            （下側）欄
          </span>
        ),
        isDeleteButton: true,
      },
    ];

    this.pdfFiles = [
      {
        category_code: 3, // 3:案内図(PDF)
        title: (
          <span className='label' style={this.styles.labelText}>
            案内図(PDF)
          </span>
        ),
      },
    ];

    this.otherImageFiles = [
      {
        category_code: 4, // 4:画像1
        title: '',
      },
      {
        category_code: 5, // 5:画像2
        title: '',
      },
      {
        category_code: 6, // 6:画像3
        title: '',
      },
      {
        category_code: 7, // 7:画像4
        title: '',
      },
    ];

    this.defaultImages = {
      12: '/default/ky_center.png',
      13: '/default/ky_right.png',
      14: '/default/ky_work_center.png',
      15: '/default/ky_work_right.png',
      16: '/default/oxy_above_right.png',
      17: '/default/oxy_below.png',
    };
  }

  componentDidMount() {
    this.setFieldImages();
    this.setField();
    this.setKeyplans();
  }

  setFieldImages() {
    const { fieldId } = this.state;
    const categoryCodes = _.union(
      _.map(this.imageFiles, 'category_code'),
      _.map(this.pdfFiles, 'category_code'),
      _.map(this.otherImageFiles, 'category_code')
    );
    FieldImageService.list(fieldId, {
      category_codes: categoryCodes,
    }).then(resp => {
      if (resp.result) {
        this.setFormValues(resp.data.entities.field_images);
      }
    });
  }

  setField() {
    const { fieldId } = this.state;
    FieldService.info(fieldId).then(resp => {
      if (resp.result) {
        this.setFieldValues(resp.data.entities.field);
      }
    });
  }

  /**
   * @description キープラン情報取得
   */
  setKeyplans() {
    FieldImageService.keyplan(this.state.fieldId, {
      order: 'order_number_asc',
      display_flag: DISPLAY_FLAG.use.id,
    }).then(response => {
      if (response.result === true) {
        const keyplanLists = response.data.entities.field_images;
        this.setState({ keyplanLists });
      }
    });
  }

  setFormValues = fieldImages => {
    const formValues = [];
    _.each(fieldImages, fieldImage => {
      const formValue = {};
      _.each(Object.keys(this.defaultValues), key => {
        formValue[key] = fieldImage[key];
      });
      formValues.push(formValue);
    });
    this.setState({
      fieldImages: formValues,
    });
  };

  setFieldValues = field => {
    const formValues = {};
    _.each(Object.keys(this.fieldDefaultValues), key => {
      if (field[key]) {
        formValues[key] = field[key];
      } else {
        formValues[key] = _.isUndefined(this.fieldDefaultValues[key])
          ? ''
          : this.fieldDefaultValues[key];
      }
    });
    this.setState({
      field: formValues,
      created: field.created_at,
      updated: field.overall_updated_at,
      errors: {},
      fieldImageErrors: [],
    });
  };

  setFieldImageData = (e, categoryCode) => {
    const fieldImages = [...this.state.fieldImages];
    _.each(fieldImages, (fieldImage, index) => {
      if (fieldImage.category_code === categoryCode) {
        fieldImage[e.target.name] = deleteControlCode(e.target.value);
        fieldImages[index] = fieldImage;
      }
    });
    this.setState({ fieldImages });
  };

  setFieldData = e => {
    const field = { ...this.state.field };
    field[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ field });
  };

  /**
   * @description 選択ファイル設定(作業安全指示書用画像～酸欠帳票用画像(下側)欄)
   * @param {*} target 操作ファイル要素
   * @param {number} categoryCode ファイルカテゴリーコード
   */
  setImage = async (target, categoryCode) => {
    if (!target.files[0]) {
      return;
    }

    const isTypeResult = await ImageUtility.fileTypeCheck(target.files[0]);
    const isSizeResult = await ImageUtility.fileSizeCheck(target.files[0]);
    if (!isTypeResult) {
      target.value = '';
      return this.imageTypeErrorDialog();
    }
    if (!isSizeResult) {
      target.value = '';
      return this.imageSizeErrorDialog();
    }

    const createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    const fieldImages = [...this.state.fieldImages];
    let updateFlag = false;

    fieldImages.map(fieldImage => {
      if (categoryCode === fieldImage.category_code) {
        fieldImage.image_url = createObjectURL(target.files[0]);
        fieldImage.file_name = target.files[0];
        updateFlag = true;
        delete fieldImage.delete;
      }
    });
    if (!updateFlag) {
      fieldImages.push({
        category_code: categoryCode,
        image_url: createObjectURL(target.files[0]),
        file_name: target.files[0],
      });
    }
    this.setState({ fieldImages });
  };

  /**
   * @description 選択ファイル設定(その他現場資料)
   * @param {*} target 操作ファイル要素
   * @param {number} categoryCode ファイルカテゴリーコード
   */
  async setImages(target, categoryCode) {
    if (!target.files[0]) {
      return;
    }

    const isTypeResult = await ImageUtility.approvalFileType(
      target.files[0],
      APPROVAL_FILE_TYPE
    );
    const isSizeResult = await ImageUtility.fileSizeCheck(target.files[0]);
    if (!isTypeResult) {
      target.value = '';
      return this.imagesTypeErrorDialog();
    }
    if (!isSizeResult) {
      target.value = '';
      return this.imageSizeErrorDialog();
    }

    const fieldImages = [...this.state.fieldImages];
    const createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    const fileName = target.files[0].name;
    const fileExtension = fileName
      .split('.')
      .pop()
      .toLowerCase();

    const firstFileExtensionArray = ['jpg', 'jpeg', 'png', 'gif'];
    if (_.includes(firstFileExtensionArray, fileExtension)) {
      let fileExtensionId;
      switch (fileExtension) {
        case 'jpg':
        case 'jpeg':
          fileExtensionId = FILE_EXTENSION_ID.JPG;
          break;
        case 'png':
          fileExtensionId = FILE_EXTENSION_ID.PNG;
          break;
        case 'gif':
          fileExtensionId = FILE_EXTENSION_ID.GIF;
          break;
      }
      let updateFlag = false;
      fieldImages.map(fieldImage => {
        if (categoryCode === fieldImage.category_code) {
          updateFlag = true;
          fieldImage.image_url = createObjectURL(target.files[0]);
          fieldImage.file_extension_id = fileExtensionId;
          fieldImage.file_name = target.files[0];
          delete fieldImage.delete;
        }
      });
      if (!updateFlag) {
        fieldImages.push({
          category_code: categoryCode,
          image_url: createObjectURL(target.files[0]),
          file_name: target.files[0],
        });
      }
      this.etc_file_flag === false;
    }

    const secondFileExtensionArray = ['pdf', 'xlsx'];
    if (_.includes(secondFileExtensionArray, fileExtension)) {
      let paramFileName, fileExtensionId;
      if (fileExtension === 'pdf') {
        paramFileName = 'pdf_name';
        fileExtensionId = FILE_EXTENSION_ID.PDF;
      } else {
        paramFileName = 'xlsx_name';
        fileExtensionId = FILE_EXTENSION_ID.ETC;
      }
      let updateFlag = false;
      fieldImages.map(fieldImage => {
        if (categoryCode === fieldImage.category_code) {
          updateFlag = true;
          fieldImage[paramFileName] = fileName;
          fieldImage.file_name = target.files[0];
          fieldImage.file_extension_id = fileExtensionId;
          delete fieldImage.delete;
        }
      });
      if (!updateFlag) {
        fieldImages.push({
          category_code: categoryCode,
          comment: fileName,
          [paramFileName]: fileName,
          pdf_name: target.files[0],
        });
      }
      this.etc_file_flag === true;
    }

    this.setState({ fieldImages });
  }

  removeImage = categoryCode => {
    const { fieldImages, fieldImageErrors } = this.state;
    fieldImages.map(fieldImage => {
      if (categoryCode === fieldImage.category_code) {
        fieldImage.delete = true;
        delete fieldImage.image_url;
        delete fieldImage.file_name;
        delete fieldImage.comment;
      }
    });
    const result = _.filter(fieldImageErrors, fieldImageError => {
      if (fieldImageError.category_code !== categoryCode) {
        return {
          category_code: fieldImageError.category_code,
          message: fieldImageError.message,
        };
      }
    });
    this.setState({
      fieldImages,
      fieldImageErrors: result,
    });
    // onChangeイベントを感知
    document.getElementById(`image-url-${categoryCode}`).value = '';
  };

  /**
   * @description 選択ファイル設定(案内図(PDF))
   * @param {*} target 操作ファイル要素
   * @param {number} categoryCode ファイルカテゴリーコード
   */
  setPdf = async (target, categoryCode) => {
    if (!target.files[0]) {
      return;
    }

    const isTypeResult = await ImageUtility.approvalFileType(target.files[0], [
      'pdf',
    ]);
    const isSizeResult = await ImageUtility.fileSizeCheck(target.files[0]);
    if (!isTypeResult) {
      target.value = '';
      return this.pdfTypeErrorDialog();
    }
    if (!isSizeResult) {
      target.value = '';
      return this.imageSizeErrorDialog();
    }

    const fieldImages = [...this.state.fieldImages];
    let updateFlag = false;

    fieldImages.map(fieldImage => {
      if (categoryCode === fieldImage.category_code) {
        updateFlag = true;
        fieldImage.comment = target.files[0].name;
        fieldImage.pdf_name = target.files[0].name;
        fieldImage.file_name = target.files[0];
        delete fieldImage.delete;
      }
    });

    if (!updateFlag) {
      fieldImages.push({
        category_code: categoryCode,
        comment: target.files[0].name,
        pdf_name: target.files[0].name,
        file_name: target.files[0],
      });
    }
    this.setState({ fieldImages });
  };

  addOtherImageForm = () => {
    const fieldImages = [...this.state.fieldImages];
    const usedCategoryCodes = _.map(fieldImages, 'category_code');
    const otherImageCategoryCodes = _.map(
      this.otherImageFiles,
      'category_code'
    );
    const useCategoryCodes = _.difference(
      otherImageCategoryCodes,
      usedCategoryCodes
    );
    if (useCategoryCodes.length === 0) {
      alert('「画像」の登録は4件までです。');
    } else {
      const fieldImage = _.extend({}, this.defaultValues);
      fieldImage.category_code = useCategoryCodes[0];
      fieldImages.push(fieldImage);
      this.setState({ fieldImages });
    }
  };

  getFieldErrors = () => {
    const { field } = this.state;
    const result = validationByJoi(this.fieldSchema, field);
    const errors = {};
    if (!result.status) {
      _.each(result.messages, (message, name) => {
        errors[name] = message;
      });
    }
    this.setState({
      errors,
    });
    return errors;
  };

  /**
   * 画像TypeErrorダイアログ表示
   * @param FieldImage {object}
   */
  imageTypeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: '選択可能な画像形式は「JPEG、GIF、PNG」ファイルです',
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像TypeErrorダイアログ表示
   * @param FieldImage {object}
   */
  pdfTypeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: '選択可能なファイル形式は「PDF」ファイルです',
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像サイズErrorダイアログ表示
   * タイトル：「登録失敗」
   * テキスト：「ファイルアップロードの上限は15MBです。 15MB以下の画像を選択してください。」
   * @param FieldImage {object}
   */
  imageSizeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: messageUtility.getMessage('E-000-011'),
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像TypeErrorダイアログ表示
   * @param FieldImage {object}
   * テキスト：「選択可能なファイル形式は「{0}」ファイルです。」
   */
  imagesTypeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: messageUtility.getMessage('E-000-038', APPROVAL_FILE_TYPE),
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  eventSubmit = () => {
    const errors = this.getFieldErrors();
    if (
      Object.keys(errors).length === 0 &&
      this.state.fieldImageErrors.length === 0
    ) {
      const { fieldId, field, fieldImages } = this.state;
      FieldService.oxygenLackFieldImageCategoryCodesUpdate(fieldId, field).then(resp => {
        if (resp.result) {
          dialogLoader.show(Edited);
          this.setField();
          this.setState({
            errors: {},
          });
        }
      });
      _.each(fieldImages, fieldImage => {
        if (fieldImage.delete && !!fieldImage.id) {
          FieldImageService.del(fieldId, fieldImage.id).then(resp => {
            if (resp.result) {
              this.setFieldImages();
            }
          });
          return;
        }
        delete fieldImage.delete;
        if (fieldImage.file_type_id === null) {
          delete fieldImage.file_type_id;
        }
        if (fieldImage.id && typeof fieldImage.file_name !== 'object') {
          delete fieldImage.file_name;
          FieldImageService.update(fieldId, fieldImage.id, fieldImage).then(
            resp => {
              if (resp.result) {
                this.setFieldImages();
              }
            }
          );
        } else if (
          fieldImage.file_name !== null &&
          typeof fieldImage.file_name === 'object'
        ) {
          const uploadParam = {
            category_code: fieldImage.category_code,
          };
          fieldImage.order_number = 0;
          fieldImage.display_flag = 1;
          FieldImageService.upload(fieldId, uploadParam, fieldImage).then(
            resp => {
              if (resp.result) {
                this.setFieldImages();
              }
            }
          );
        }
      });
    } else {
      this.setState({ errors });
    }
  };

  render() {
    const deleteStyle = {
      display: 'flex',
      marginLeft: 10,
      width: 30,
      height: 30,
      padding: 0,
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
    };
    const deleteIcon = fieldImage => {
      const fileType = parseInt(fieldImage.file_type_id, 10);
      const noDelete = 4;

      if (!!fieldImage.file_name && fileType !== noDelete) {
        return (
          <button
            style={deleteStyle}
            onClick={() =>
              this.events.form.removeImage(fieldImage.category_code)
            }
          >
            <i className='i-close i-3x' />
          </button>
        );
      }
      return null;
    };

    const getImagesMessaage = categoryCode => {
      const errors = this.state.fieldImageErrors;
      let message = null;
      _.each(errors, error => {
        if (error.category_code === categoryCode) {
          message = (
            <div className='form-list__alert show'>{error.message}</div>
          );
        }
      });
      return message;
    };

    const imageFileElement = (categoryCode, isDeleteButton) => {
      let fieldImageTmp = {};
      _.each(this.state.fieldImages, function(fieldImage, index) {
        if (categoryCode === fieldImage.category_code) {
          fieldImageTmp = fieldImage;
          fieldImageTmp.key = `imageFileElement-${index}`;
        }
      });
      return (
        <div className='form-list__element' key={fieldImageTmp.key}>
          <label
            htmlFor={`image-url-${categoryCode}`}
            className='btn input-file'
            onMouseEnter={e => {
              const tooltip = e.target.querySelector('.tooltip');
              tooltip.style.top = `${e.target.offsetTop + 40}px`;
              if (!tooltip.classList.contains('show')) {
                tooltip.classList.add('show');
              }
            }}
            onMouseLeave={e => {
              const tooltip = e.target.querySelector('.tooltip');
              if (tooltip) {
                tooltip.classList.remove('show');
              }
            }}
            style={styles.input}
          >
            ファイル選択
            <input
              id={`image-url-${categoryCode}`}
              name='file_name'
              type='file'
              style={{ display: 'none' }}
              accept='image/jpeg, image/png, image/gif'
              onChange={e => this.events.form.setImage(e.target, categoryCode)}
            />
            <div
              className='tooltip'
              style={{
                left: -80,
              }}
            >
              <div className='tooltip__text'>
                JPEG、GIF、PNGファイルをアップロードして下さい。
              </div>
            </div>
          </label>
          <div className='form-list__files'>
            {fieldImageTmp.image_url ? (
              <div className='form-list__file'>
                <div
                  className='img-form-thumbnail'
                  style={{ minHeight: '240px' }}
                >
                  <img
                    src={
                      fieldImageTmp.image_url
                        ? fieldImageTmp.image_url
                        : `${API.endpoint}/images${
                            this.defaultImages[categoryCode]
                          }`
                    }
                    alt=''
                  />
                </div>
                {isDeleteButton && (
                  <React.Fragment>{deleteIcon(fieldImageTmp)}</React.Fragment>
                )}
              </div>
            ) : null}
          </div>
          {getImagesMessaage(categoryCode)}
        </div>
      );
    };

    const pdfFileElement = categoryCode => {
      let fieldImageTmp = {};
      // eslint-disable-next-line no-unused-vars
      _.each(this.state.fieldImages, function(fieldImage, index) {
        if (categoryCode === fieldImage.category_code) {
          fieldImageTmp = fieldImage;
        }
      });
      const pdfLink = fieldImageTmp => {
        if (typeof fieldImageTmp.file_name === 'object') {
          return <div className=''>{fieldImageTmp.file_name.name}</div>;
        }
        if (fieldImageTmp.image_url) {
          return (
            <div className=''>
              <a href={fieldImageTmp.image_url} target='_blank'>
                {fieldImageTmp.comment
                  ? fieldImageTmp.comment
                  : fieldImageTmp.file_name}
              </a>
            </div>
          );
        }
        return null;
      };

      return (
        <div className='form-list__element'>
          <label
            htmlFor={`image-url-${categoryCode}`}
            className='btn input-file'
            onMouseEnter={e => {
              const tooltip = e.target.querySelector('.tooltip');
              tooltip.style.top = `${e.target.offsetTop + 40}px`;
              if (!tooltip.classList.contains('show')) {
                tooltip.classList.add('show');
              }
            }}
            onMouseLeave={e => {
              const tooltip = e.target.querySelector('.tooltip');
              if (tooltip) {
                tooltip.classList.remove('show');
              }
            }}
            style={styles.input}
          >
            ファイル選択
            <input
              id={`image-url-${categoryCode}`}
              name='file_name'
              type='file'
              style={{ display: 'none' }}
              accept='application/pdf'
              onChange={e => this.events.form.setPdf(e.target, categoryCode)}
            />
            <div
              className='tooltip'
              style={{
                left: -91,
              }}
            >
              <div className='tooltip__text'>
                PDFファイルをアップロードしてください。
              </div>
              <div className='tooltip__text'>
                PDFは、職長さんが様々な場所で閲覧する可能性があるため、
              </div>
              <div className='tooltip__text'>
                十分に考慮してアップロードしてください。
              </div>
            </div>
          </label>
          <div className='form-list__files' style={{ display: 'flex' }}>
            <div
              className='form-list__file'
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {pdfLink(fieldImageTmp)}
              {deleteIcon(fieldImageTmp)}
            </div>
          </div>
          {getImagesMessaage(categoryCode)}
        </div>
      );
    };

    const otherImageFileElement = categoryCode => {
      let fieldImageTmp = {};
      _.each(this.state.fieldImages, function(fieldImage) {
        if (categoryCode === fieldImage.category_code) {
          fieldImageTmp = fieldImage;
        }
      });
      const pdfLink = fieldImageTmp => {
        if (
          typeof fieldImageTmp.file_name === 'object' &&
          fieldImageTmp.file_name !== null
        ) {
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {fieldImageTmp.file_name.name}
            </div>
          );
        }
        if (fieldImageTmp.image_url) {
          return (
            <div className=''>
              <a href={fieldImageTmp.image_url} target='_blank'>
                {fieldImageTmp.file_name}
              </a>
            </div>
          );
        }
        return null;
      };
      return _.map(this.state.fieldImages, fieldImage => {
        if (categoryCode === fieldImage.category_code) {
          return (
            <div
              key={categoryCode}
              className='form-list-attachments__item'
              style={styles.item}
            >
              <div style={styles.item}>
                <select
                  name='file_type_id'
                  value={fieldImage.file_type_id}
                  onChange={e =>
                    this.events.form.setFieldImageData(e, categoryCode)
                  }
                >
                  <option value='1'>工程表</option>
                  <option value='2'>現場資料</option>
                  <option value='3'>その他</option>
                </select>
                <div className='form-list__alert' />
              </div>
              <div style={styles.item}>
                <input
                  type='text'
                  name='comment'
                  value={_.isNull(fieldImage.comment) ? '' : fieldImage.comment}
                  onChange={e =>
                    this.events.form.setFieldImageData(e, categoryCode)
                  }
                  maxLength={50}
                  placeholder='コメント'
                />
                <div className='form-list__alert' />
              </div>
              <div style={{ borderBottom: '1px solid #efefef' }}>
                <label
                  htmlFor={`image-url-${fieldImage.category_code}`}
                  className='btn input-file'
                  onMouseEnter={e => {
                    const tooltip = e.target.querySelector('.tooltip');
                    tooltip.style.top = `${e.target.offsetTop + 40}px`;
                    if (!tooltip.classList.contains('show')) {
                      tooltip.classList.add('show');
                    }
                  }}
                  onMouseLeave={e => {
                    const tooltip = e.target.querySelector('.tooltip');
                    if (tooltip) {
                      tooltip.classList.remove('show');
                    }
                  }}
                  style={styles.input}
                >
                  ファイル選択
                  <input
                    id={`image-url-${fieldImage.category_code}`}
                    name='file_name'
                    type='file'
                    style={{ display: 'none' }}
                    onChange={e =>
                      this.events.form.setImages(
                        e.target,
                        fieldImage.category_code
                      )
                    }
                  />
                  <div
                    className='tooltip'
                    style={{
                      left: -30,
                    }}
                  >
                    <div className='tooltip__text'>
                      JPEG、GIF、PNG、PDF、XLSXファイルをアップロードして下さい。
                    </div>
                  </div>
                </label>
                <div
                  className='form-list__files'
                  style={{ position: 'relative' }}
                >
                  {this.etc_file_flag === false ||
                  (fieldImageTmp.file_extension_id !== FILE_EXTENSION_ID.ETC &&
                    fieldImageTmp.file_extension_id !== FILE_EXTENSION_ID.PDF &&
                    fieldImageTmp.image_url) ? (
                    <div className='form-list__file'>
                      <div
                        className='img-form-thumbnail'
                        style={{
                          height: 240,
                        }}
                      >
                        <img src={fieldImage.image_url} alt='' />
                      </div>
                      {deleteIcon(fieldImage)}
                    </div>
                  ) : (
                    <div
                      className='form-list__files'
                      style={{
                        display: 'flex',
                        overflow: 'unset',
                        wordBreak: 'break-all',
                      }}
                    >
                      {fieldImageTmp.hasOwnProperty('file_name') &&
                        fieldImageTmp.file_name !== null && (
                          <div className='form-list__file'>
                            {pdfLink(fieldImageTmp)}
                            {deleteIcon(fieldImageTmp)}
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
              {getImagesMessaage(categoryCode)}
            </div>
          );
        }
      });
    };

    const { styles } = this;

    return (
      <div className='setting-main__body main__body__new-slide--fixed'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 帳票用画像・その他資料</title>
        </Helmet>
        <div id='setting-header' className='setting-header'>
          <div className='setting-header__item'>
            <button
              className='btn--effective'
              type='submit'
              disabled=''
              onClick={() => this.events.form.submit()}
            >
              更新
            </button>
            <div className='--fx-auto' />
          </div>
          <div className='setting-header__description'>
            <Description type='primary'>
              {messageUtility.getMessage('W-001-307')}
            </Description>
          </div>
        </div>
        <div className='setting-main__table'>
          <ul className='form-list'>
            {_.map(this.imageFiles, (imageFile, index) => (
              <React.Fragment key={index}>
                <li key={index} className='form-list__item' style={styles.item}>
                  <div className='form-list__label' style={styles.label}>
                    {imageFile.title}
                  </div>
                  {imageFileElement(
                    imageFile.category_code,
                    imageFile.isDeleteButton
                  )}
                </li>
                {imageFile.category_code === 15 && (
                  <li key={imageFile.category_code} className='form-list__item'>
                    <div className='form-list__label' style={styles.label}>
                      <span className='label' style={styles.labelText}>
                        酸欠帳票に使用するキープラン
                      </span>
                    </div>
                    <div className='form-list__element form-list__element--fixed-width'>
                      <select
                        name='oxygen_lack_field_image_category_code'
                        value={
                          this.state.field.oxygen_lack_field_image_category_code
                        }
                        onChange={e => this.events.form.setFieldData(e)}
                      >
                        <option value={0}>キープランを選択</option>
                        {_.map(this.state.keyplanLists, (keyplan, index) => (
                          <option key={index} value={keyplan.category_code}>
                            {`${keyplan.label} : ${keyplan.comment}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </li>
                )}
              </React.Fragment>
            ))}
            {_.map(this.pdfFiles, (pdfFile, index) => (
              <li key={index} className='form-list__item'>
                <div className='form-list__label' style={styles.label}>
                  {pdfFile.title}
                </div>
                {pdfFileElement(pdfFile.category_code)}
              </li>
            ))}
            <li className='form-list__item'>
              <div className='form-list__label' style={styles.label}>
                <span className='label' style={styles.labelText}>
                  その他現場資料
                </span>
              </div>
              <div className='form-list__element'>
                <div className='form-list-attachments'>
                  {_.map(this.otherImageFiles, (otherImageFile, index) => {
                    // eslint-disable-line
                    return otherImageFileElement(otherImageFile.category_code);
                  })}
                  <div className='form-list-attachments__footer'>
                    <button
                      className='btn--sub'
                      onClick={() => this.events.form.addOtherImageForm()}
                    >
                      写真を追加
                    </button>
                  </div>
                </div>
              </div>
            </li>
            <li className='form-list__item'>
              <div className='form-list__label' style={styles.label}>
                <span className='label' style={styles.labelText}>
                  登録日時
                </span>
              </div>
              <div className='form-list__element'>
                <p>
                  {moment(this.state.created).format(
                    'YYYY/MM/DD(ddd) HH:mm:ss'
                  )}
                </p>
              </div>
            </li>
            <li className='form-list__item'>
              <div className='form-list__label' style={styles.label}>
                <span className='label' style={styles.labelText}>
                  更新日時
                </span>
              </div>
              <div className='form-list__element'>
                <p>
                  {moment(this.state.updated).format(
                    'YYYY/MM/DD(ddd) HH:mm:ss'
                  )}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldImages.jsx